<template>
	<div class="small-12 mainWrap sisu flex">
		<sisu-left/>
		<sign-up-form/>
	</div>
</template>

<script>

	// Import the components
	import SisuLeft from '@/components/sisu/shared/SisuLeft.vue'
	import SignUpForm from '@/components/sisu/SignUpForm.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'SignUp',

		/*
		**  Register the components
		*/

		components: {

			SisuLeft,
			SignUpForm

		}

	}

</script>